import React from "react";
import PropTypes from "prop-types";
import { Modal } from "react-bootstrap";
import { getLastUpdatedDateColor, getLastUpdatedTootlTip } from "../../dashboard-util/dashboard-utils";
import "../dashboard-group-head-tech.scss";

const TechGroupHeadDealTrackerModal = React.memo(({
    show,
    onHide,
    item,
    title,
    subTitle,
}) => {
    const { ProjectMembers = [] } = item || {};

    return (
        <Modal
            show={show}
            onHide={onHide}
            contentClassName="dashboard-modal-styles"
            dialogClassName="dashboard-modal"
            scrollable={true}
            data-testid="modal"
        >
            <Modal.Header
                className="dashboard-modal-header"
                closeButton
                data-testid="modal-header"
            >
                <Modal.Title className="dashboard-modal-title ml-4" data-testid="modal-title">
                    {title}
                    <p className="subDepartmentTitle" data-testid="modal-subTitle">{subTitle}</p>
                </Modal.Title>
            </Modal.Header>

            <Modal.Body className="techModalBody" data-testid="modal-body">
                <table className="TechDashboard" data-testid="project-table">
                    <thead className="MemberTableColumnHeader techHeader">
                        <tr className="tableColumnTitles tableHeader">
                            <th className="col-md-1 col-sm-1 textEllipsis headerSorted">Analyst/Associate</th>
                            <th className="col-md-1 col-sm-1 textEllipsis headerSorted">Last Week Hours</th>
                            <th className="col-md-1 col-sm-1 textEllipsis headerSorted">Weekend Hours</th>
                            <th className="col-md-1 col-sm-1 textEllipsis headerSorted">Total Hours</th>
                            <th className="col-md-1 col-sm-1 textEllipsis headerSorted">Current Week Hours</th>
                            {getLastUpdatedTootlTip(<th className="col-md-1 col-sm-1 textEllipsis headerSorted">Last Updated</th>)}
                        </tr>
                    </thead>
                    <tbody className="tableBody techBody">
                        {   ProjectMembers.length > 0 &&
                            ProjectMembers?.map((pm) => {
                                return (
                                    <tr key={pm.UserId} data-testid={`project-${pm.UserId}`}>
                                        <td className="col-md-1 col-sm-1 mt-2 ">
                                            <div className="violationContainer">
                                                {pm.AnalystAssociate}
                                            </div>
                                        </td>
                                        <td className="col-md-1 col-sm-1 mt-2">
                                            {pm.LastWeekHours}
                                        </td>
                                        <td className="col-md-1 col-sm-1 mt-2">
                                            {pm.WeekendHours}
                                        </td>
                                        <td className="col-md-1 col-sm-1 mt-2">
                                            {pm.TotalHours}
                                        </td>
                                        <td className="col-md-1 col-sm-1 mt-2">
                                            {pm.CurrentWeekHours}
                                        </td>
                                        <td className="col-md-1 col-sm-1 mt-2" style={{ color: getLastUpdatedDateColor(pm.LastUpdated) }}>
                                            {pm.LastUpdated ?? "-"}
                                        </td>
                                    </tr>
                                );
                            })}
                    </tbody>
                </table>
            </Modal.Body>
        </Modal>
    );
});

TechGroupHeadDealTrackerModal.propTypes = {
    item: PropTypes.shape({
        ProjecId: PropTypes.number.isRequired,
        ProjectName: PropTypes.string.isRequired,
        ProjectMembers: PropTypes.arrayOf(PropTypes.shape({
            UserId: PropTypes.string,
            AnalystAssociate: PropTypes.string,
            LastWeekHours: PropTypes.string,
            WeekendHours: PropTypes.string,
            TotalHours: PropTypes.string,
            CurrentWeekHours: PropTypes.string,
            LastUpdated: PropTypes.string
        })),
        GroupHeads: PropTypes.arrayOf(PropTypes.shape({
            Name: PropTypes.string.isRequired,
         })),
        ProjectDynamicFields: PropTypes.arrayOf(PropTypes.shape({
            Data: PropTypes.string
        })),
        Project: PropTypes.shape({
            Name: PropTypes.string
        })
    }),
    show: PropTypes.bool.isRequired,
    onHide: PropTypes.func.isRequired,
    title: PropTypes.string.isRequired,
    subTitle: PropTypes.string,
};

TechGroupHeadDealTrackerModal.defaultProps = {
    item: {
        ProjectId: 0,
        ProjectName: "",
        ProjectMembers: [],
        GroupHeads: [],
        ProjectDynamicFields: [],
        Project: null,
    }
};

export default TechGroupHeadDealTrackerModal;